import React, { memo } from 'react'
import EmptyTableContent from '../error/EmptyTableContent'
import CategoriesBody from './table-body/CategoriesBody'
import { removeSwal } from '../../functions/removeSwal'

function CarCategoriesTable({ search, carModels, setCarModels }) {
  const removeHandler = (id) => {
    removeSwal('admin/site-options/car-models/remove', carModels, id, setCarModels)
  }
  return (
    <div className="relative rounded-2xl border border-light-gray dark:border-gray-700 overflow-auto scroll-smooth">
      {carModels.filter(({ model }) => model.toLowerCase().includes(search.toLowerCase())).length >
        0 && carModels?.length > 0 ? (
        <CategoriesBody search={search} carModels={carModels} removeHandler={removeHandler} />
      ) : (
        <EmptyTableContent text={'دسته بندی خودرویی ثبت نشده است.'} />
      )}
    </div>
  )
}

export default memo(CarCategoriesTable)
